import React, {FC, useEffect, useState} from "react";
import {Button, Col, Modal, Row, Form, notification, Input, Skeleton, Tree} from "antd";
import {addRoleWithCms, editRolePermissions, editRoleWithCms, findById, getPrivileges} from "../actions";
import {DataNode} from "antd/es/tree";

const AddRole: FC<any> = (props: any) => {
    const [isSaving, setSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedPermissions, setSelectedPermissions] = useState<string[]>([]);
    const [permissions, setPermissions] = useState<DataNode[]>([]);

    const [form] = Form.useForm();
    const title = props.selectedRole ? "Редактирование роли" : "Добавление новой роли";

    const loadData = async () => {
        setIsLoading(true);

        try {
            if (props.selectedRole) {
                const roleData = await findById(props.selectedRole.id);

                setSelectedPermissions(roleData.data.privileges);
                form.setFieldsValue({
                    nameRu: roleData.data.name && roleData.data.name.ru
                });
            }

            const priv = await getPrivileges();

            setPermissions(priv.data);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (props.isModalOpen === true) {
            loadData();
        }
    }, [props.isModalOpen]);

    const handleOk = () => {
        form.validateFields().then(
            () => {
                setSaving(true);

                if (props.selectedRole) {
                    edit();
                } else {
                    add();
                }
            }
        );
    };

    const triggerOk = () => {
        props.handleOk();
        form.resetFields();
        setSelectedPermissions([]);
        setSaving(false);
    };

    const add = async () => {
        const res = await addRoleWithCms(props.roleService, form.getFieldsValue());
        await setRolePermissions(res.data.id);

        notification['success']({
            message: 'Роль успешно создана',
        });

        triggerOk();
    };

    const edit = async () => {
        await editRoleWithCms(props.roleService, {...form.getFieldsValue(), id: props.selectedRole.id});
        await setRolePermissions(props.selectedRole.id);

        notification['success']({
            message: 'Роль успешно изменена',
        });

        triggerOk();
    };

    const setRolePermissions = async (roleId: string) => {
        await editRolePermissions(selectedPermissions, roleId)
    };

    const handleOnCheck = (checkedKeys: string[]) => {
        setSelectedPermissions(checkedKeys.filter(x => x.includes('PRIV_')));
    };

    const handleCancel = () => {
        props.handleCancel();
        form.resetFields();
        setSelectedPermissions([]);
        setIsLoading(false);
    };


    return (
        <Modal title={title}
               open={props.isModalOpen}
               onOk={handleOk}
               onCancel={handleCancel}
               destroyOnClose
               width='40%'
               footer={[
                   <Button className="admin" key="back" onClick={handleCancel}>
                       Отмена
                   </Button>,
                   <Button key="submit" type="primary" className="admin" onClick={handleOk} loading={isSaving}>
                       Сохранить
                   </Button>
               ]}
        >
            <div className="add-role">
                {isLoading ? (
                    <Skeleton />
                ) : (
                    <Form layout="vertical" form={form}>
                        <Row className="mt-3">
                            <Col span="24">
                                <Form.Item
                                    label="Наименование"
                                    name="nameRu"
                                    rules={[{ required: true, message: 'Обязательное поле' }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span="24">
                                <Tree
                                    checkable
                                    treeData={permissions}
                                    onCheck={handleOnCheck}
                                    defaultCheckedKeys={selectedPermissions}
                                />
                            </Col>
                        </Row>
                    </Form>
                )}
            </div>
        </Modal>
    );
};

export default AddRole;
